<template>
  <div class="page-block left-zone">
    <div ref="textBlock" v-html="content.text"></div>
    <!-- <div class="zoom-button" @click="toggleZoom"><FontAwesomeIcon icon="chevron-up" size="sm"/></div> -->
  </div>
  <div class="page-block right-zone">
    <div class="scrollable-list">

      <div class="collection-item-list">
        <CollectionIndexItem v-for="item in menu" :key="item.id" :item="item"/>
      </div>
    </div>
    <div class="overlay gradient-left"></div>
    <div class="overlay gradient-right"></div>
  </div>
</template>
  
  <style>
  .left-zone{
    position:relative;
  }
  .zoom-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    display: block;
    font-size: 2rem;
    transition: 500ms;
  }
  #app.zoomed .zoom-button{
    rotate: 180deg;
  }
  @media only screen and (min-width: 1024px) {
    .zoom-button {
      display: none;
    }
  }
  .right-zone {
      padding: 1rem 0;
      .scrollable-list{
        overflow-x: auto;
        overflow-y: hidden;
        height: 100%;
      }
      position: relative;
      transform: scale(1,1);
      
  
      .overlay {
      position:absolute;
      top: 0;
      bottom: 0;
      width: 1rem;
      }
  
      .gradient-left {
      left: 0;
      background: rgb(255,255,255);
      background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
      }
  
      .gradient-right {
      right: 0;
      background: rgb(255,255,255);
      background: linear-gradient(-90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
      }
  }
  
  </style>
  
  <script setup>
  import { reactive, watch, ref } from 'vue'
  import { useRoute } from 'vue-router'

  import CollectionIndexItem from '@/components/CollectionIndexItem.vue'
  
  import { library } from '@fortawesome/fontawesome-svg-core'
  import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
  // import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  
  //import sirapi from '@/sirapi'

  const VUE_APP_SIRAPI_BASE_URL=process.env.VUE_APP_SIRAPI_BASE_URL
  const VUE_APP_API_BASE_URL=process.env.VUE_APP_API_BASE_URL
  const VUE_APP_MAIN_MENU_FR_ID=process.env.VUE_APP_MAIN_MENU_FR_ID
  const VUE_APP_MAIN_MENU_EN_ID=process.env.VUE_APP_MAIN_MENU_EN_ID
  
  library.add(faChevronUp)
  
  const content = reactive({text: "", gallery_ids: []})
  
  // const zoomed = ref(false)
  const menu = ref([])

  const route = useRoute()
  
  function hydrate(){
    fetch(VUE_APP_SIRAPI_BASE_URL + "/main-menu/" + (route.params.lang=='fr'? VUE_APP_MAIN_MENU_FR_ID : VUE_APP_MAIN_MENU_EN_ID ))
    .then((response) => {return response.json()})
    .then((data) => {menu.value = data})
    
    fetch(VUE_APP_API_BASE_URL + "/pages/" + (route.params.lang=='fr'?VUE_APP_MAIN_MENU_FR_ID:VUE_APP_MAIN_MENU_EN_ID))
      .then((response) => {
        return response.json()
      })
      .then((data) =>{
        content.text = '<h1>' + data.title.rendered + '</h1>' + data.content.rendered
      })
  }

  // function toggleZoom (){
  //   // if(!zoomed.value){
  //   //   document.getElementById("app").classList.add("zoomed")
  //   //   zoomed.value = true
  //   // } else {
  //   //   //document.getElementById("app").style.setProperty("grid-template-rows", "3rem 1fr 8rem")
  //   //   document.getElementById("app").classList.remove("zoomed")
  //   //   zoomed.value = false
  //   // }
  // }

  watch( () => route.path, () => {
      hydrate()
    }
  )

  hydrate()
  
  </script>